import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgRadioChecked = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 12,
        cy: 12,
        r: 5
    }));
export default SvgRadioChecked;
